module.exports = __webpack_public_path__ + "img/banner.f08e1970.jpg";